import { render, staticRenderFns } from "./PerformanceEvaluation.vue?vue&type=template&id=2157c3f0&"
import script from "./PerformanceEvaluation.vue?vue&type=script&lang=js&"
export * from "./PerformanceEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2157c3f0')) {
      api.createRecord('2157c3f0', component.options)
    } else {
      api.reload('2157c3f0', component.options)
    }
    module.hot.accept("./PerformanceEvaluation.vue?vue&type=template&id=2157c3f0&", function () {
      api.rerender('2157c3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/PerformanceEvaluation.vue"
export default component.exports